export default {

  init() {

    // Cache
    let $countdown;

    if ($.idleTimeout !== undefined && $('#idle-timeout-dialog').length > 0) {
      $.idleTimeout('#idle-timeout-dialog', '.modal-content button:last', {
        idleAfter: 60 * 60, // 1hr de inactividad
        timeout: 30000, // 30 segundos
        pollingInterval: 5, // Cada 5 segundos envia el keepalive
        keepAliveURL: 'session/keepalive',
        serverResponseEquals: 'OK',
        onTimeout() {
          window.location = 'lock';
        },
        onIdle() {
          $('#idle-timeout-dialog').modal('show');
          $countdown = $('#idle-timeout-counter');

          $('#idle-timeout-dialog-keepalive').on('click', () => {
            $('#idle-timeout-dialog').modal('hide');
          });

          $('#idle-timeout-dialog-logout').on('click', function () {
            $('#idle-timeout-dialog').modal('hide');
            $.idleTimeout.options.onTimeout.call(this);
          });
        },
        onCountdown(counter) {
          $countdown.html(counter); // Actualiza el contador
        }
      });
    }
  }
};
